export default __webpack_public_path__ + "static/media/SmoobuV2.99fcac41.png";